export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./collab.vue?vue&type=template&id=04009fca&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/base/modals/collab.vue?vue&type=template&id=04009fca&
// module id = 1348
// module chunks = 0